/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsGetTeamDefault } from "../../funcs/budgetsGetTeamDefault.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTeamDefaultBudgetsRequest$inboundSchema,
};

export const tool$budgetsGetTeamDefault: ToolDefinition<typeof args> = {
  name: "budgets-get-team-default",
  description: `List per-team default budgets

Returns the org's per-team default budgets (self-set and/or operator ceiling). A default budget applies to every team in the org against that team's own spend counter, unless an explicit team budget of the same owner and period exists for them. It has no spend gauge of its own. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only. Callable by cluster admins, or org admins for their own organization (owner=org).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsGetTeamDefault(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
